import script from "./UpdateAndMaintenanceForm.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateAndMaintenanceForm.vue?vue&type=script&setup=true&lang=js"

import "./UpdateAndMaintenanceForm.vue?vue&type=style&index=0&id=1a7b0f55&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a7b0f55"]])

export default __exports__